// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImportOutlinedSvg from "@fishx/icons-svg/es/asn/FileImportOutlined";
import FishxIcon from '../components/FishxIcon';

var FileImportOutlined = function FileImportOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImportOutlinedSvg
  }));
};

FileImportOutlined.displayName = 'FileImportOutlined';
export default React.forwardRef(FileImportOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileImportOutlined.js
// module id = 2718
// module chunks = 0